import { render, staticRenderFns } from "./FiltersCardV2.vue?vue&type=template&id=0d4b65b8&scoped=true"
import script from "./FiltersCardV2.vue?vue&type=script&lang=js"
export * from "./FiltersCardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b65b8",
  null
  
)

export default component.exports